/**
 * The agents the signed-in user may view as (D2-SEC-011, #3944), or null when
 * they may not use read-only "View as agent" at all (the server answers 403).
 * Every entry point renders nothing for a null list; the server re-checks on
 * start regardless.
 */
import { useEffect, useState } from "react";
import { getViewAsTargets } from "../../api/viewAs";
import type { ViewAsPerson } from "../../lib/viewAs";

export function useViewAsTargets(): ViewAsPerson[] | null {
  const [targets, setTargets] = useState<ViewAsPerson[] | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    getViewAsTargets(controller.signal)
      .then(setTargets)
      .catch(() => setTargets(null));
    return () => controller.abort();
  }, []);
  return targets;
}
